import { render } from "./CoreModal.vue?vue&type=template&id=53a15850"
import script from "./CoreModal.vue?vue&type=script&lang=js"
export * from "./CoreModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__